import { Box, Typography } from "@material-ui/core";
import { ButtonPlus, Header } from "../../shared/Style/Style";

interface ShareLinksHeaderProps {
  onOpenModal: () => void;
  canManage: boolean;
}

export const ShareLinksHeader = ({
  onOpenModal,
  canManage,
}: ShareLinksHeaderProps) => {
  return (
    <>
      <Header>Шаринг-ссылки</Header>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        my={6}
      >
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ maxWidth: "540px" }}
        >
          Короткі посилання на контент ArBook+ для мобільного застосунку.
          Користувач відкриває посилання й переходить до контенту.
        </Typography>
        {canManage && (
          <ButtonPlus variant="contained" onClick={onOpenModal}>
            Додати
          </ButtonPlus>
        )}
      </Box>
    </>
  );
};
